import {
  ADD_BILLING_ADDRESS_REQUEST,
  ADD_BILLING_ADDRESS_SUCCESS,
  ADD_BILLING_ADDRESS_FAILURE,
  RESET_BILLING_ADDRESS_STATE,
  UPDATE_BILLING_ADDRESS_REQUEST,
  UPDATE_BILLING_ADDRESS_SUCCESS,
  UPDATE_BILLING_ADDRESS_FAILURE,
  FETCH_BILLING_ADDRESS_REQUEST,
  FETCH_BILLING_ADDRESS_SUCCESS,
  FETCH_BILLING_ADDRESS_FAILURE,
  VIEW_BILLING_ADDRESS_REQUEST,
  VIEW_BILLING_ADDRESS_SUCCESS,
  VIEW_BILLING_ADDRESS_FAILURE,
  DELETE_BILLING_ADDRESS_REQUEST,
  DELETE_BILLING_ADDRESS_SUCCESS,
  DELETE_BILLING_ADDRESS_FAILURE,
} from './BillingAddressTypes';

export const addBillingAddressRequest = (payload) => ({
  type: ADD_BILLING_ADDRESS_REQUEST,
  payload,
});

export const addBillingAddressSuccess = (data) => ({
  type: ADD_BILLING_ADDRESS_SUCCESS,
  payload: data,
});

export const addBillingAddressFailure = (error) => ({
  type: ADD_BILLING_ADDRESS_FAILURE,
  payload: error,
});
export const resetBillingAddressState = () => ({
  type: RESET_BILLING_ADDRESS_STATE,
});

export const fetchBillingAddressesRequest = (customerId) => ({
  type: FETCH_BILLING_ADDRESS_REQUEST,
  payload: customerId,
});

export const fetchBillingAddressesSuccess = (data) => ({
  type: FETCH_BILLING_ADDRESS_SUCCESS,
  payload: data,
});

export const fetchBillingAddressesFailure = (error) => ({
  type: FETCH_BILLING_ADDRESS_FAILURE,
  payload: error,
});

export const viewBillingAddressRequest = (addressId) => ({
  type: VIEW_BILLING_ADDRESS_REQUEST,
  payload: addressId,
});

export const viewBillingAddressSuccess = (data) => ({
  type: VIEW_BILLING_ADDRESS_SUCCESS,
  payload: data,
});

export const viewBillingAddressFailure = (error) => ({
  type: VIEW_BILLING_ADDRESS_FAILURE,
  payload: error,
});

export const updateBillingAddressRequest = ({ id, data }) => ({
  type: UPDATE_BILLING_ADDRESS_REQUEST,
  payload: { id, data },
});

export const updateBillingAddressSuccess = (data) => ({
  type: UPDATE_BILLING_ADDRESS_SUCCESS,
  payload: data,
});

export const updateBillingAddressFailure = (error) => ({
  type: UPDATE_BILLING_ADDRESS_FAILURE,
  payload: error,
});
export const deleteBillingAddressRequest = (id) => ({
  type: DELETE_BILLING_ADDRESS_REQUEST,
  payload: id,
});
export const deleteBillingAddressSuccess = (message) => ({
  type: DELETE_BILLING_ADDRESS_SUCCESS,
  payload: message,
});
export const deleteBillingAddressFailure = (error) => ({
  type: DELETE_BILLING_ADDRESS_FAILURE,
  payload: error,
});
